import { FormattedMessage } from "react-intl";
import ClickIcon from "../../../../../icons/Analytics/click";
import HeartIcon from "../../../../../icons/Analytics/heart";
import ViewIcon from "../../../../../icons/Analytics/view";
import Recommend from "../../../../../newUXAssets/icons/Recommend";
import { ACard, IconContainer } from "../../styles";

export function AnalyticsCard({ number, analyticType, label }) {
  const cardCollection = new Map();
  cardCollection.set("impressions", {
    icon: (
      <IconContainer bg="#eff5ff">
        <HeartIcon />
      </IconContainer>
    ),
  });
  cardCollection.set("views", {
    icon: (
      <IconContainer bg="#FFF4f1">
        <ViewIcon />
      </IconContainer>
    ),
  });
  cardCollection.set("interations", {
    icon: (
      <IconContainer bg="#FFF7e1">
        <ClickIcon />
      </IconContainer>
    ),
  });
  cardCollection.set("recommendations", {
    icon: (
      <IconContainer bg="#FCF1FF">
        <Recommend fill="#bd11d9" stroke="none" />
      </IconContainer>
    ),
  });
  const type = cardCollection.get(analyticType);

  return (
    <ACard>
      {type.icon}
      <p>{number}</p>
      <h3>
        <FormattedMessage id={label} />
      </h3>
    </ACard>
  );
}
